import type { SVGProps } from 'react';
import type { IconName } from '../../constants/iconNames';
import { ICON_SYMBOL_PREFIX } from '../../utils/iconSprite';
import styles from './Icon.module.css';

export type { IconName };

interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name' | 'children'> {
  name: IconName;
  title?: string;
}

const classOf = (extra?: string) => `app-icon ${styles.icon}${extra ? ` ${extra}` : ''}`;

export default function Icon({ name, title, className, ...rest }: IconProps) {
  return (
    <svg
      className={classOf(className)}
      viewBox="0 0 24 24"
      data-icon={name}
      focusable="false"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      aria-label={title}
      {...rest}
    >
      {title && <title>{title}</title>}
      <use href={`#${ICON_SYMBOL_PREFIX}${name}`} />
    </svg>
  );
}

// For markup built outside React (Photo Sphere Viewer markers).
export function iconHtml(name: IconName, className?: string): string {
  return `<svg class="${classOf(className)}" viewBox="0 0 24 24" data-icon="${name}" focusable="false" aria-hidden="true"><use href="#${ICON_SYMBOL_PREFIX}${name}"/></svg>`;
}
